<template>
    <div>
        <div class="modal-header py-0 d-flex flex-column crm-modal-header">
            <div class="row w-100 ">
                <div class="col-12 pt-3 pb-1 pr-0 d-flex justify-content-center align-items-center dNone">
                    <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{this.isEditMode?$ml.get("EDIT_COMPANY"):$ml.get("ADD_COMPANY")}}</h5>
                    <button type="button" @click="closeButton"  class="close "  aria-label="Close">
                        <span aria-hidden="true" class="font-40">&times;</span>
                    </button>
                </div>
            </div>
            <ul class="row nav hpx-50 px-3 mincrm-dynamic-tabs"  role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="deal-tab" data-toggle="tab" :href="isEditMode?'#updateOrganization':'#newOrganization'" role="tab" aria-controls="organization" aria-selected="true">{{$ml.get('DETAIL_COMPANY')}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="org-customField-tab" data-toggle="tab" :href="isEditMode?'#updateOrgCustomField':'#newOrgCustomField'" role="tab" aria-controls="orgCustomField" aria-selected="false">{{$ml.get('SPECIAL_AREA')}}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="file-tab" @click="watchUpdated=watchUpdated+1" data-toggle="tab" :href="isEditMode?'#updateOrgFile':'#newOrgFile'" role="tab" aria-controls="file" aria-selected="false">{{$ml.get('FILE')}}</a>
                </li>
            </ul>
            <button type="button" class="close d-none" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="font-40">&times;</span>
            </button>
        </div>
        <div class="modal-body py-3 px-md-4 crm-modal-body">
            <div class="tab-content">
                <div class="tab-pane fade show active py-2" :id="isEditMode?'updateOrganization':'newOrganization'" role="tabpanel" aria-labelledby="organization-tab">
                    <div class="row">
                        <div class="col-sm-6 btn-group pb-2 crmButonGroupsType d-flex align-items-baseline justify-content-between justify-content-lg-start">
                            <label class="new-label pr-4">{{$ml.get('TYPE_COMPANY')}}</label>
                            <div class="btn-group ">
                            <button class="btn btn-click h40" @click="organization['isCandidate']=true" :class="{active:organization['isCandidate']==true}" :disabled="isEditMode && organization['x']!==true" style="border-radius:4px 0px 0px 4px">{{$ml.get('LEAD')}}</button>
                            <button class="btn btn-click h40" @click="organization['isCandidate']=false" :class="{active:organization['isCandidate']==false}" :disabled="isEditMode && organization['x']!==true"  >{{$ml.get('CUSTOMER')}}</button>
                            </div>
                        </div>

                        <div class="col-sm-6 btn-group d-flex justify-content-end crmButonGroupsType align-items-baseline justify-content-between justify-content-lg-end">
                            <label class="new-label pr-4">{{$ml.get('COMPANY_STATUS')}}</label>
                            <div class="btn-group">
                            <button class="btn btn-click h40 " @click="organization['status']=true" :class="{active:organization['status']==true}" style="border-radius:4px 0px 0px 4px">{{$ml.get('ACTIVE')}}</button>
                            <button class="btn btn-click h40" @click="organization['status']=false" :class="{active:organization['status']==false}">{{$ml.get('PASSIVE')}}</button>
                            </div>
                        </div>
                        
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-6 mt-3">
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('COMPANY_NAME')}}*</label>
                                    <input type="text" v-model="organization['name']" :disabled="isEditMode && organization['x']!==true" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12">
                                            <label class="new-label">{{$ml.get('RELATED_PERSON')}}</label>
                                            <div class="position-relative w-100">
                                                <input type="text" v-model="contactKeyword" :disabled="isEditMode && organization['x']!==true" class="new-input">
                                                <!-- <i class="fa fa-plus input-plus-absolute-right light-gray-color"></i> -->
                                            </div>
                                            <ul class="new-dropdown autocomplete-results" v-show="items.length>0">
                                                <li class="autocomplete-result f-w-normal font-family-bold f-14" v-show='isHiddenContact' v-for='(result, i) in items' :key="i" @click="setResult(result)">{{result.n}} {{result.sn}}<span v-if="result.organizationName!=undefined" class="color-red">({{filterName(result.organizationName)}})</span><span v-else class="color-red">(Firma Yok)</span></li>
                                            </ul>
                                            <ul class="new-dropdown autocomplete-results" v-show="items.length<1 && isHiddenContact">  
                                                <li class="autocomplete-result"> {{$ml.get('NOT_FOUND_PERSON')}}</li>
                                                <li class="autocomplete-result f-w-normal font-family-bold f-14 color-primary" @click="addContact=true,isHiddenContact=false"> {{$ml.get('ADD_PERSON')}} <i class="fa fa-plus float-right color-primary"></i></li>
                                            </ul>
                                            <ul  class="mt-2 p-0" v-if="organization.contacts.length>0">
                                                <li type="button" v-for="i in organization.contacts" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                                    <span class="float-left">{{getFullNameOfContact(i)}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem(organization.contacts,i,'contact')"><span aria-hidden="true">&times;</span></span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="row m-0">
                                        <div v-show="addContact" class="col-12">
                                            <div class="row addContact">
                                                <div class="col-12 d-flex justify-content-between align-items-center fastAdd pt-2">
                                                    <label class="h-36 py-2 m-0"> {{$ml.get('QUICK_ADD_CONTACT')}}</label>
                                                    <span class="fa fa-close font-m cursor-pointer" @click="closeContactButton" ></span>
                                                </div>
                                                <div class="col-12">
                                                    <label class="new-label">{{$ml.get('NAME')}} {{$ml.get('SURNAME')}}* </label>
                                                    <input type="text" v-model="addContactArray['name']" :placeholder="addContactArray['name']"  class="new-input">
                                                </div>
                                                <div class="col-12">
                                                    <label class="new-label">Gsm*</label>
                                                    <input type="number" onwheel="this.blur()" v-model="addContactArray['gsm']"  class="new-input">
                                                </div>
                                                <div class="col-12">
                                                    <label class="new-label">{{$ml.get('E_MAIL')}}*</label>
                                                    <input type="text" v-model="addContactArray['mail']"  class="new-input">
                                                </div>
                                                <div class="col-12 organizationBtnStyle my-3">
                                                    <button @click="saveContactButton" class="btn-new save mcBgDark">{{$ml.get('SAVE')}}</button>
                                                    <button @click="closeContactButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                    
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('PHONE')}}</label>
                                    <div class="w-100 position-relative">
                                        <input type="number" onwheel="this.blur()" v-model="phoneNumber" :disabled="isEditMode && organization['x']!==true" @blur="addArray('phoneNumbers',phoneNumber),phoneNumber=''" v-on:keyup.enter="addArray('phoneNumbers',phoneNumber),phoneNumber=''" class="new-input">
                                        <i class="fa fa-plus h40 input-plus-absolute-right crm-input-icon-color" @click="addArray('phoneNumbers',phoneNumber),phoneNumber=''"></i>
                                    </div>
                                    <ul  class="mt-2 p-0" v-if="organization.phoneNumbers.length>0">
                                        <li type="button" v-for="i in organization.phoneNumbers" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                            <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem(organization.phoneNumbers,i)"><span aria-hidden="true">&times;</span></span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('FAX')}}</label>
                                    <div class="w-100 position-relative">
                                        <input type="number" onwheel="this.blur()" v-model="faxNumber" :disabled="isEditMode && organization['x']!==true" @blur="addArray('faxNumbers',faxNumber),faxNumber=''" v-on:keyup.enter="addArray('faxNumbers',faxNumber),faxNumber=''" class="new-input">
                                        <i class="fa fa-plus h40 input-plus-absolute-right crm-input-icon-color" @click="addArray('faxNumbers',faxNumber),faxNumber=''"></i>
                                    </div>
                                    <ul  class="mt-2 p-0" v-if="organization.faxNumbers.length>0">
                                        <li type="button" v-for="i in organization.faxNumbers" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                            <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem(organization.faxNumbers,i)"><span aria-hidden="true">&times;</span></span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('E_MAIL')}}</label>
                                    <div class="w-100 position-relative">
                                        <input type="text" v-model="emailAddress" :disabled="isEditMode && organization['x']!==true" @blur="addArray('emailAddresses',validEmail(emailAddress)),emailAddress=''" v-on:keyup.enter="addArray('emailAddresses',validEmail(emailAddress)),emailAddress=''" class="new-input">
                                        <i class="fa fa-plus h40 input-plus-absolute-right crm-input-icon-color" @click="addArray('emailAddresses',emailAddress),emailAddress=''"></i>
                                    </div>
                                    <ul  class="mt-2 p-0" v-if="organization.emailAddresses.length>0">
                                        <li type="button" v-for="i in organization.emailAddresses" class="w-100 bg-new-gray border-0 h-36 btn-new pl-3 mb-1 d-flex align-items-center justify-content-between">
                                            <span class="float-left">{{i}}</span> <span class="badge font-lg float-right cursor-pointer h-100 border-top-bottom-right-radius-4" @click="deleteItem(organization.emailAddresses,i)"><span aria-hidden="true">&times;</span></span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">Web</label>
                                    <input type="text" v-model="organization['webAddr']" :disabled="isEditMode && organization['x']!==true" class="new-input">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 mt-sm-3">
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('ADDRESS')}}</label>
                                    <textarea type="text" :disabled="isEditMode && organization['x']!==true" v-model="organization['addr']" class="new-textarea"></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('COUNTRY')}}</label>
                                    <CountrySelect v-model="organization.country" :placeholder="$ml.get('COUNTRY')" :countryName="true"  :country="organization.country" @changeCountry="changeCountry" topCountry="TR" class="new-select bg-white light-gray-color"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('CITY')}}</label>
                                    <region-select v-model="organization.city" @input="changeCity" :country="organization.country" :regionName="true" :countryName="true" :placeholder="$ml.get('CITY')" :region="organization.city" :disabled="isEditMode && organization['x']!==true" class="new-select bg-white light-gray-color"/>
                                </div>
                            </div>
                            <div class="row" v-if="isTurkeyCountry || organization['town']">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('DISTRICT')}}</label>
                                    <select v-model="organization['town']" :disabled="isEditMode && organization['x']!==true" class="new-select bg-white light-gray-color">
                                        <option :value="town" v-for="(town,index) in townList[organization.city]">{{town}}</option> 
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('POST_CODE')}}</label>
                                    <input type="text" :disabled="isEditMode && organization['x']!==true" v-model="organization['postalCode']" class="new-input">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('TAX_ADMINISTRATION')}}</label>
                                    <input type="text" v-model="organization['taxOffice']" :disabled="isEditMode && organization['x']!==true" class="new-input">
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('TAX_NUMBER')}}</label>
                                    <input type="text" v-model="organization['taxNo']" :disabled="isEditMode && organization['x']!==true" class="new-input">
                                </div>
                            </div>
                            
                            <!-- <div class="row">
                                <div class="col-12">
                                    <label class="new-label">{{$ml.get('PASSIVE')}} / {{$ml.get('ACTIVE')}}</label>
                                    <div class="d-flex align-items-center">
                                        <label class="switch heightSwitch m-0">
                                        <input type="checkbox" v-model="organization.status">
                                        <span class="slider round true"></span>
                                        </label>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade py-2" :id="isEditMode?'updateOrgCustomField':'newOrgCustomField'" role="tabpanel" aria-labelledby="orgCustomField-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <special-area type="save" ref="customFields" :edit="isEditMode" @returnCustomData="returnCustomData($event)" :editArray="setData" postField="organization" :user="user" :users="users" @updateData="$emit('updateData')" @returnCustomField="returnCustomField=$event" :customField="customFieldArray" :allcustomFieldArray="customFieldArray"></special-area>
                    </div>
                </div>
                <div class="tab-pane fade py-2" :id="isEditMode?'updateOrgFile':'newOrgFile'" role="tabpanel" aria-labelledby="file-tab">
                    <div class="w-100" v-show="customFieldArray.length>0">
                        <file   :organizationData='data'
                                :watchUpdated="watchUpdated"
                                :customerFiles="customerFiles"
                                @showCustomerFile="showCustomerFile($event)"
                                @addNewFile="addNewFile($event)"
                                @deleteFile="function($event){ 
                                    for(k in this.customerFiles){
                                    if(this.customerFiles[k]['$oid']==$event['oid']){
                                        this.customerFiles.splice(k,1)
                                    }
                                }}"
                        ></file>
                    </div>
                </div>
            </div>
           
        </div>
        <div class="row crm-modal-footer stickyBtn mx-0">
            <hr class="col-12 p-0 mt-0 d-none d-md-block">
            <div class="col-12 dealBtnStyle pb-3 pr-4" v-if="isEditMode===false">
                <button @click="saveButton" class="btn-new save ml-2">{{$ml.get('SAVE')}}</button>
                <button @click="closeButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
            </div>
            <div class="col-12 dealBtnStyle pb-3 pr-4" v-if="isEditMode">
                <button @click="saveButton" class="btn-new save ml-2">{{$ml.get('EDIT')}}</button>
                <button @click="closeButton" class="btn-new" >{{$ml.get('CANCEL')}}</button>
            </div>
        </div>
        
             <!-- Değişiklik uyarısı Modal -->
        <div class="modal fade h-100" id="changeAlertModalOrganization2" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content px-2 py-3 bg-white">
                    <div class="modal-body text-center">
                        <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 1.5rem; border-radius: 50%;"></i>
                        <h2 class="my-3" style="color:#47495A;">Uyarı</h2>
                        <p style="color: #53565E; font-size: 16px;">
                            Değişiklikleri kaydetmek istiyor musunuz?
                        </p>
                    </div>
                    <div class="modal-footer d-flex align-items-center justify-content-center">
                        <button type="button" class="btn bg-transparent btn-lg mr-2" style="font-weight: 500; font-size: 16px;" data-dismiss="modal" @click="changeAlertModalCancel">{{$ml.get('NO')}}</button>
                        <button type="button" class="btn btn-lg" style="background: #FF0000; color: #fff; font-weight: 600; font-size: 16px;" data-dismiss="modal" @click="saveButton">{{$ml.get('YES')}}</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import axios from 'axios'
import _ from 'underscore'
import specialArea from '@/components/customField'
import CountrySelect from '@/components/country-select'
import RegionSelect from '@/components/region-select'
import File from './file.vue'
import { fullname, truncate } from '@/services/gridFormatters'
export default {
    name: 'newOrganization',
    props:["data","customFieldArray","user","users","updateData","clearModal","isEditMode"],
    components:{
        'special-area':specialArea,
        CountrySelect,
        RegionSelect,
        File
    },
    data () {
        return {
            organization:{
                isCandidate:true,
                name:"",
                contacts:[],
                phoneNumbers:[],
                faxNumbers:[],
                emailAddresses:[],
                webAddr:"",
                taxOffice:"",
                taxNo:"",
                addr:"",
                country:"",
                city:"",
                town:"",
                postalCode:"",
                x:true,
                status:true
            },
            contactKeyword:"",
            isHiddenContact:false,
            isHiddenNewContact:false,
            addContact:false,
            items:[],
            addContactArray:[],
            phoneNumber:'',
            faxNumber:'',
            emailAddress:'',
            isTurkeyCountry:false,
            returnCustomField:[],
            setData:{},
            watchUpdated:0,
            customerFiles:[]
        }
    },
    computed: {
        ...mapState([
            'cityList',
            'townList',
            'countryList',
            'taxOfficeList',
            'baseUrl',
            'editLine'
        ])
    },
    mounted(){
        $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
    },
    methods:{
        getFullNameOfContact(contact){
            return fullname(contact)
        },
        filterName(value){
            return truncate(String(value), 15)
        },
        changeCity(){
            this.organization['town']=""
        },
        returnCustomData(data){
            this.setData=data
        },
        setResult(result){
            
            if(result.organization!==undefined){
                if(confirm("Seçtiğiniz kişi bir firma ile ilişkilidir, bu ilişkiyi değiştirmek istiyor musunuz?")){
                    if(this.isEditMode==true){
                        var form = {}
                        form.objId = this.data._id.$oid
                        form.newContactId = result._id.$oid
                        this.relateContactToOrganization(form).then((response) => {
                            console.log('--relateContactToOrganization data')
                            console.log(response)
                            if(response.status.code==0){
                                this.$notify({ group: 'foo',
                                    type: 'success', 
                                    title: this.$ml.get('COMPANY_AND_CONTACT_ASSOCIATED'),
                                    text: response.status.desc 
                                })
                            }else{
                                this.$notify({ group: 'foo',
                                    type: 'error', 
                                    title: this.$ml.get('ERROR'),
                                    text: response.status.desc 
                                })
                            }
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                    this.organization.contacts.push(result)
                }
            }else{
                if(this.isEditMode==true){
                    var form = {}
                    form.objId = this.data._id.$oid
                    form.newContactId = result._id.$oid
                    this.relateContactToOrganization(form).then((response) => {
                        console.log('--relateContactToOrganization data')
                        console.log(response)
                        if(response.status.code==0){
                            this.$notify({ group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('COMPANY_AND_CONTACT_ASSOCIATED'),
                                text: response.status.desc 
                            })
                        }else{
                            this.$notify({ group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: response.status.desc 
                            })
                        }
                    }).catch(e => {
                        console.log(e)
                    })
                }
                this.organization.contacts.push(result)
            }
            
            this.contactKeyword=""
            this.isHiddenContact = false
            this.items=[]
            
        },
        addArray(array,value){
            
            if(value!="" && value!=undefined){
                if(array==='emailAddresses'){
                    if(this.organization.emailAddresses.indexOf(value)===-1){
                        if(typeof(value)==='object'){
                            for(var i in value){
                                if(value[i]!=="" && value[value[i]]!==false){
                                    this.organization.emailAddresses.push(value[i])
                                }
                            }
                        }else{
                            if(value!=="" && value!==false){
                                this.organization.emailAddresses.push(value)
                            }
                        }
                    }
                }else if(array==='faxNumbers'){
                    
                    if(this.organization.faxNumbers.indexOf(value)===-1){
                        if(typeof(value)==='object'){
                            for(var i in value){
                                if(value[i]!=="" && value[value[i]]!==false){
                                    this.organization.faxNumbers.push(value[i])
                                }
                            }
                        }else{
                            if(value!=="" && value!==false){
                                this.organization.faxNumbers.push(value)
                            }
                        }
                    }
                }else if(array==='phoneNumbers'){
                    
                    if(this.organization.phoneNumbers.indexOf(value)===-1){
                        if(typeof(value)==='object'){
                            for(var i in value){
                                if(value[i]!=="" && value[value[i]]!==false){
                                    this.organization.phoneNumbers.push(value[i])
                                }
                            }
                        }else{
                            if(value!=="" && value!==false){
                                this.organization.phoneNumbers.push(value)
                            }
                        }
                    }
                    
                }
            }
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(email.length>0&&email!==undefined){
                if(re.test(email)===false){
                    this.$notify({ group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('INVALID_EMAIL'),
                        text: this.$ml.get('PLEASE_INSERT_A_VALID_EMAIL')
                    })
                    return false
                }else{
                    return email
                }
            }else{
                return false
            }
        },
        deleteItem(array,item,type){
            if(type=="contact"){
                if(this.isEditMode==true){
                    var form = {}
                    form.newContactId=item._id.$oid
                    this.removeOrganizationContact(form).then((response) => {
                        console.log('--removeOrganizationContact data')
                        console.log(response)
                        if(response.status.code==0){
                            this.$notify({ group: 'foo',
                                type: 'success', 
                                title: "Firma ve Kişi ilişkisi kaldırıldı",
                                text: response.status.desc 
                            })
                            this.organization.contacts.forEach((value, index) => {
                                if(array.indexOf(item)==index){
                                    this.organization.contacts.splice(index, 1);
                                }
                            });
                        }else{
                            this.$notify({ group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: response.status.desc 
                            })
                        }
                    }).catch(e => {
                        console.log(e)
                    })
                }else{
                    this.organization.contacts.forEach((value, index) => {
                        if(array.indexOf(item)==index){
                            this.organization.contacts.splice(index, 1);
                        }
                    });
                }
                
                
            }
            var index = array.indexOf(item);
            
            if (index > -1) {
                array.splice(index, 1);
            }
        },
        saveButton(){
            let dataObj={}
            let obj={}
            let url=""
            if(this.isEditMode==true){
                if(this.organization.isCandidate!==this.data.isCandidate){
                    obj["isCandidate"]=this.organization['isCandidate']
                }
                
                if(this.organization["name"]===""){
                    this.$notify({ group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('PLEASE_ENTER_A_COMPANY_NAME'),
                        text: this.$ml.get('PLEASE_ENTER_A_COMPANY_NAME') })
                    return false
                }else{
                    if(this.organization.name!==this.data.name){
                        obj['name']=this.organization['name']
                    }
                    
                }
                if(this.organization.phoneNumbers.length>0){
                    obj["phoneNumbers"]=this.organization.phoneNumbers
                }else{
                    obj["phoneNumbers"]=null
                }
                //obj["phoneNumbers"]=''
                if(this.organization.faxNumbers.length>0){
                    obj["faxNumbers"]=this.organization.faxNumbers
                }else{
                    obj["faxNumbers"]=null
                }
                if(this.organization.emailAddresses.length>0){
                    obj["emailAddresses"]=this.organization.emailAddresses
                }else{
                    obj["emailAddresses"]=null
                }
                //obj["emailAddresses"]=''
                if(this.organization.webAddr!==""){
                    obj["webAddr"]=this.organization.webAddr
                }else{
                    obj["webAddr"]=null
                }
                //obj["emailAddresses"]=''
                if(this.organization.status!==""){
                    obj["status"]=this.organization.status
                }else{
                    obj["status"]=null
                }
                if(this.organization.taxOffice!==""){
                    obj["taxOffice"]=this.organization.taxOffice
                }else{
                    obj["taxOffice"]=null
                }
                if(this.organization.taxNo!==""){
                    obj["taxNo"]=this.organization.taxNo
                }else{
                    obj["taxNo"]=null
                }
                if(this.organization.addr!==""){
                    obj["addr"]=this.organization.addr
                }else{
                    obj["addr"]=null
                }
                if(this.organization.country!==""){
                    obj["country"]=this.organization.country
                }else{
                    obj["country"]=null
                }
                if(this.organization.city!==""){
                    obj["city"]=this.organization.city
                } else{
                    obj["city"]=null
                }
                if(this.organization.town!=="" && this.organization.town!==undefined){
                    obj["town"]=this.organization["town"]
                }else{
                    obj["town"]=null
                }
                if(this.organization.postalCode!=""){
                    obj["postalCode"]=this.organization.postalCode
                }else{
                    obj["postalCode"]=null
                }
                
                console.log("obj")
                console.log(obj)
            }else{
                
                obj["isCandidate"]=this.organization['isCandidate']
                
                if(this.organization["name"]===""){
                    this.$notify({ group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('PLEASE_ENTER_A_COMPANY_NAME'),
                        text: this.$ml.get('PLEASE_ENTER_A_COMPANY_NAME') })
                    return false
                }else{
                    
                        obj['name']=this.organization['name']
                    
                }
                if(this.organization.contacts!==null){
                    var contacts =[]
                    for(var contact in this.organization.contacts){
                        contacts.push(this.organization.contacts[contact]._id)
                    }
                    obj['contacts']=contacts
                }
                if(this.organization.phoneNumbers!==null){
                    obj["phoneNumbers"]=this.organization.phoneNumbers
                }
                //obj["phoneNumbers"]=''
                if(this.organization.faxNumbers!==null){
                    obj["faxNumbers"]=this.organization.faxNumbers
                }
                if(this.organization.emailAddresses!==null){
                    obj["emailAddresses"]=this.organization.emailAddresses
                }
                if(this.organization.status!==status){
                    obj["status"]=this.organization.status
                }
                //obj["emailAddresses"]=''
                if(this.organization.webAddr!==""){
                    obj["webAddr"]=this.organization.webAddr
                }
                if(this.organization.taxOffice!==""){
                    obj["taxOffice"]=this.organization.taxOffice
                }
                
                if(this.organization.taxNo!==""){
                    obj["taxNo"]=this.organization.taxNo
                }
                if(this.organization.addr!==""){
                    obj["addr"]=this.organization.addr
                }
                if(this.organization.country!==""){
                    obj["country"]=this.organization.country
                }
                if(this.organization.city!==""){
                    obj["city"]=this.organization.city
                } 
                if(this.organization.town!==""){
                    obj["town"]=this.organization["town"]
                }
                if(this.organization.postalCode!=""){
                    obj["postalCode"]=this.organization.postalCode
                }
                
                for (var customId in this.returnCustomField){
                    if (typeof this.returnCustomField[customId] !== 'function') {
                        obj[customId] = this.returnCustomField[customId]
                    }
                }
                
            }
            
            /*
            if(this.organization.x!==this.data.x){
                obj["x"]=this.organization["x"]
            }
            */
            
          
            //return false
            
            if(this.isEditMode===false){
                url = "addOrganization"
                obj["customerFileIds"]=this.customerFiles.map(function(i){
                    return {$oid:i.$oid}
                })
                dataObj["organizationInputObj"]=obj
                this.postOrganization(url,dataObj)
                this.customerFiles=[]
            }else{
                url = "updateOrganization"
                dataObj["objId"]=this.data._id.$oid
                // obj["customerFileIds"]=this.customerFiles.map(function(i){
                //     return {$oid:i.$oid}
                // })
                obj["customerFileIds"]=this.customerFiles
                dataObj["updateObj"]=obj
                this.postOrganization(url,dataObj)
                this.customerFiles=[]   
                const fileComponent = this.$root && this.$root.$refs && this.$root.$refs.file
                if (fileComponent && typeof fileComponent.inputFileNameClear === 'function') {
                    fileComponent.inputFileNameClear()
                }
            }
        },
        changeAlertModalCancel(){
            setTimeout(() => {
                $(".crm-modal-body").css("display","block")
                $(".crm-modal-header").css("position","sticky")
                $(".crm-modal-footer").css("display","flex")
                $(".crm-modal-content").css("width","100% ")
            }, 300);
          
        },
        closeButton(){
            if(
                this.organization.name=="" && 
                this.organization['addr']=="" && 
                this.contactKeyword=="" &&
                this.phoneNumber=="" && 
                this.organization.phoneNumbers=="" && 
                this.emailAddress=="" && 
                this.organization.emailAddresses=="" && 
                this.organization.webAddr=="" && 
                this.organization.country=="" &&
                this.organization.city=="" && 
                this.organization.postalCode=="" && 
                this.organization.taxOffice=="" &&
                this.organization.taxNo=="" &&
                this.organization.status==true &&
                this.faxNumber=="" && 
                this.organization.faxNumbers==""
              ){
                $("#add").modal('hide')
                $("#addOrganizationModal").modal('hide')
                this.clear()
            }
            else{
               if(this.isEditMode===true){
                   console.log(window.location.pathname.indexOf("contactCard"));
                   if(window.location.pathname.indexOf("contactCard")==1 || window.location.pathname.indexOf("organizationCard")==1){
                        $(".crm-modal-body").css("display","none")
                        $(".crm-modal-header").css("position","absolute ")
                        $(".crm-modal-footer").css("display","none ")
                        $(".crm-modal-content").css("width","0 ")
                        $('[id=changeAlertModalOrganization2]:eq(1)').modal('show')
                        $(".modal-backdrop").css("display","none ")
                   }else{
                        $(".crm-modal-body").css("display","none")
                        $(".crm-modal-header").css("position","absolute ")
                        $(".crm-modal-footer").css("display","none ")
                        $(".crm-modal-content").css("width","0 ")
                        $('[id=changeAlertModalOrganization2]:eq(1)').modal('show')
                        $(".modal-backdrop").style.display="none";
                   }
                // $(".crm-modal-body").css("display","none")
                // $(".crm-modal-header").css("position","absolute ")
                // $(".crm-modal-footer").css("display","none ")
                // $(".crm-modal-content").css("width","0 ")
                // $('[id=changeAlertModalOrganization2]:eq(1)').modal('show')
                // $(".modal-backdrop").style.display="none";
                //  $(".modal-backdrop").css("display","none")
                // $(".modal-backdrop").modal("hide");
               }
               $(".crm-modal-body").css("display","none")
               $(".crm-modal-header").css("position","absolute ")
               $(".crm-modal-footer").css("display","none ")
               $(".crm-modal-content").css("width","0 ")
               $('[id=changeAlertModalOrganization2]:eq(0)').modal('show') 
            }
        //   else{
        //         $('[id=changeAlertModalOrganization]:eq(0)').modal('show') 
                 
        //       }
        },
        saveContactButton(){
            let name="",surName,phone,mail,url;
            let nameSplit = []
            let dataObj={}
            nameSplit = this.addContactArray['name'].split(" ")
            if(nameSplit.length-1>0){
                for (let index = 0; index < nameSplit.length-1; index++) {
                    name=name+" "+nameSplit[index]
                }
                surName=nameSplit[nameSplit.length-1]
            }else{
                name=nameSplit[0]
            }
            phone=this.addContactArray['gsm']
            mail=this.addContactArray['mail']
            if(name.length>0 && mail!=null && phone!=null ){
                if(phone.length<9){
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('PHONE_NUMBER_SHOULD_BE_AT_LEAST_10_DIGITS')
                    })
                }
                else if(!this.validEmail(mail)){
                    return false
                }else{ 
                    url = "addContact"
                    dataObj["contactInputObj"]={"n":name,"sn":surName,"gsm":phone,"email":mail}
                    this.postContact(url,dataObj)
                }
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warning', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('REQUIRED_FIELDS_CANNOT_BE_BLANK')
                })
            }
        },
        postContact(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: 'Kişi Eklendi!',
                        text: res.data.status.desc 
                    })
                    this.contactKeyword=""
                    this.isHiddenContact = false
                    this.addContact=false
                    this.addContactArray['gsm']=""
                    
                    this.items=[]
                    //if(this.isEditMode!==false){
                        this.setResult(res.data.content.contact)
                   // }
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        closeContactButton(){
            this.addContact=false
            this.addContactArray['gsm']=""
            this.addContactArray['mail']=""
        },
        clear(){
            this.organization={
                isCandidate:true,
                name:"",
                contacts:[],
                phoneNumbers:[],
                faxNumbers:[],
                emailAddresses:[],
                webAddr:"",
                taxOffice:"",
                taxNo:"",
                addr:"",
                country:"",
                city:"",
                town:"",
                postalCode:"",
                x:true,
                status:true
            }
            this.contactKeyword=""
            this.isHiddenContact=false
            this.isHiddenNewContact=false
            this.addContact=false
            this.items=[]
            this.addContactArray=[]
            this.phoneNumber=''
            this.faxNumber=''
            this.emailAddress=''
            this.isTurkeyCountry=false
            this.returnCustomField=[]
            setTimeout(() => {
            this.$refs.customFields.clearCustom();
            }, 0);
        },
        postOrganization(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    if(this.isEditMode===false){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('NEW_COMPANY_ADDED'),
                            text: res.data.status.desc 
                        })
                        
                    }else{
                        //this.organization={}
                        //this.$store.state.editLine=[]
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('COMPANY_UPDATED'),
                            text: res.data.status.desc 
                        })
                        
                    }
                    
                    // this.closeButton()
                     if(this.isEditMode===false){
                        $("#add").modal('hide')
                         this.clear()
                     }else{
                         $("#addOrganizationModal").modal('hide') 
                         this.clear()
                     } 
                    this.$emit('getData',res.data.content.organization)
                    this.$emit('updateList')
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        /*
        dataFilling(updateData){
            console.log("updateData")
            console.log(updateData)
            this.organization=updateData
            if(!this.isEmpty(updateData)){
                
                
                if(updateData.x===null){
                    this.organization["x"]=false
                }else{
                    this.organization["x"]=updateData.x
                }
                if(this.organization["country"]!==undefined){
                    //this.country=this.organization["country"]
                    if(this.organization["country"]=="Turkey" || this.organization["country"]=="Türkiye"){
                        this.isTurkeyCountry=true;
                    }else{       
                        this.isTurkeyCountry=false;
                    }
                }
                
            } 
            console.log("this.organization")
            console.log(this.organization)
        },*/
        isEmpty(obj) {
            if (obj == null) return true;
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;
            if (typeof obj !== "object") return true;
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }
            return true;
        },
        quickContact(){
             
            axios({
                method:'POST',
                url:'/quickFilterContact',
                baseURL: this.baseUrl,
                data: {
                    search:this.contactKeyword,
                    organizationId:this.organizationId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.contacts
                    this.isHiddenContact= true
                     
                }else{
                     
                }
            })
        },
        changeCountry(val){
            if(val=="Turkey" || val=="Türkiye"){
                this.isTurkeyCountry=true;
            }else{       
                this.isTurkeyCountry=false;
            }
            //this.organization['country']=this.country
        },
        ...mapActions([
            'updateLoading',
            'relateContactToOrganization',
            'removeOrganizationContact'
        ]),
        oldData(){
            this.setInputData()
        },
        setInputData(){
            this.clear()
            if(this.isEditMode){
                if(this.data.isCandidate!==undefined){
                    this.organization.isCandidate=this.data.isCandidate
                }else if(this.data.isCandidate==null){
                    this.organization.isCandidate=false
                }else{
                    this.data.isCandidate=null
                }
                if(this.data.name!==undefined){
                    this.organization.name=this.data.name
                }else{
                    this.data.name=null
                }
                if(this.data.contacts!==undefined){
                    this.organization.contacts=this.data.contacts
                }else{
                    this.data.contacts=[]
                }
                if(this.data.phoneNumbers!==undefined){
                    this.organization.phoneNumbers=this.data.phoneNumbers
                }else{
                    this.data.phoneNumbers=[]
                }
                if(this.data.faxNumbers!==undefined){
                    this.organization.faxNumbers=this.data.faxNumbers
                }else{
                    this.data.faxNumbers=[]
                }
                if(this.data.emailAddresses!==undefined){
                    this.organization.emailAddresses=this.data.emailAddresses
                }else{
                    this.data.emailAddresses=[]
                }
                
                if(this.data.webAddr!==undefined){
                    this.organization.webAddr=this.data.webAddr
                }else{
                    this.data.webAddr=null
                }
                
                if(this.data.taxOffice!==undefined){
                    this.organization.taxOffice=this.data.taxOffice
                }else{
                    this.data.taxOffice=null
                }
                
                if(this.data.taxNo!==undefined){
                    this.organization.taxNo=this.data.taxNo
                }else{
                    this.data.taxNo=null
                }
                
                if(this.data.addr!==undefined){
                    this.organization.addr=this.data.addr
                }else{
                    this.data.addr=null
                }
                
                if(this.data.country!==undefined){
                    if(this.data.country=="Turkey" || this.data.country=="Türkiye"){
                        this.isTurkeyCountry=true;
                    }else{       
                        this.isTurkeyCountry=false;
                    }
                    this.organization.country=this.data.country
                }else{
                    this.data.country=null
                }
                
                if(this.data.city!==undefined){
                    this.organization.city=this.data.city
                }else{
                    this.data.city=null
                }
                
                if(this.data.town!==undefined){
                    this.organization.town=this.data.town
                }else{
                    this.data.town=null
                }
                
                if(this.data.postalCode!==undefined){
                    this.organization.postalCode=this.data.postalCode
                }else{
                    this.data.postalCode=null
                }
                
                if(this.data.status!==undefined){
                    this.organization.status=this.data.status
                }else{
                    //this.data.x=null
                    this.organization.status=false
                }
            }
        },
        activaTabOrganization(){
            console.log("activaTab çalıştı");
            // $('#newActivityTabMenu a[href="#' + "'activityA_'+parentComp" + '"]').tab('show');
            // activaTab("'activityA_'+parentComp")
            let a=this.isEditMode ? 'updateOrganization' : 'newOrganization';
              $('.mincrm-dynamic-tabs a[href="#' + a + '"]').tab('show');
        },
        addNewFile(event){
            // this.fileId=event
            console.log(this.fileId);
            this.customerFiles.unshift(event) 
        },
        showCustomerFile(event){
            console.log(event);
            this.customerFiles=event
        },
    },
    watch: {     
        contactKeyword: _.debounce(function() {
            this.addContactArray['name']=this.contactKeyword
            this.closeContactButton()
            if(this.contactKeyword.length===0){
                this.isHiddenContact=false
                this.isHiddenNewContact=false
                this.contactId=undefined
                this.items=[]
            } 
            if(this.selectContact!==this.contactKeyword && this.contactKeyword.length!==0){
                this.quickContact() 
            }
        }, 300),
        data(){
            this.setData=this.data
            this.setInputData()
            //this.dataFilling(this.data)
        }
    },
    created(){
        this.setData=this.data
        this.setInputData()
        this.$root.$refs.newOrganization=this
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-header{
    position: sticky;
    top: 0;
    z-index: 1;
}
label{
    margin-bottom: 4px;
}
.modal-header li {
  font-size: 16px;
  margin-right: 5px;
}
.modal-header li a {
color: #93959A;
text-decoration: none;
height: 100%;
display: flex;
align-items: center;
padding: 0 13px;
}
.modal-header li a.active {
  color: #5b5f63;
  font-weight: bold;
  border-bottom: 3px solid #1991EB;
}
.companyType button{
    height: 30px;
    padding: 0 7px;
    color: #3767a0;
    background-color: transparent;
    border: 0;
    cursor: pointer;
}
.companyType button.active{
    color: white;
    background-color: #3767a0;
}
@media(max-width: 990px){
    .btn-click.active{
        z-index: 0;
    }    
}
</style>
